import { Phone, MessageCircle, Calendar } from "lucide-react";
import { BUSINESS, WA_DEFAULT } from "@/data/business";
import { useBooking } from "@/components/booking";

export default function MobileBar() {
  const { openBooking } = useBooking();
  return (
    <>
      <a
        href={WA_DEFAULT}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="floating-whatsapp-button"
        aria-label="Chat on WhatsApp"
        className="fixed bottom-6 right-6 z-40 hidden h-13 w-13 items-center justify-center rounded-full bg-charcoal p-4 text-ivory shadow-[0_10px_30px_rgba(21,19,16,0.35)] transition-transform hover:scale-105 md:flex"
      >
        <MessageCircle className="h-5 w-5" />
      </a>

      <nav
        data-testid="mobile-booking-bar"
        aria-label="Quick actions"
        className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-3 border-t border-ivory/10 bg-ink/95 pb-[env(safe-area-inset-bottom)] text-ivory backdrop-blur-md md:hidden"
      >
        <a
          href={BUSINESS.phoneTel}
          data-testid="mobile-bar-call"
          className="flex flex-col items-center gap-1 py-3 text-[11px] font-semibold tracking-wide"
        >
          <Phone className="h-5 w-5 text-champagne" /> Call
        </a>
        <a
          href={WA_DEFAULT}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="mobile-bar-whatsapp"
          className="flex flex-col items-center gap-1 border-x border-ivory/10 py-3 text-[11px] font-semibold tracking-wide"
        >
          <MessageCircle className="h-5 w-5 text-champagne" /> WhatsApp
        </a>
        <button
          onClick={() => openBooking()}
          data-testid="mobile-bar-book"
          className="flex flex-col items-center gap-1 py-3 text-[11px] font-semibold tracking-wide"
        >
          <Calendar className="h-5 w-5 text-champagne" /> Book
        </button>
      </nav>
    </>
  );
}
